module.exports = __webpack_public_path__ + "img/network-wired.13910bf8.svg";